module.exports = __webpack_public_path__ + "static/media/map-uberview.8e421d4c.png";